import React from 'react'
import { deviceDetect, filtersSlice, PAGE_SLUG } from 'Modules'
import { useSelector } from 'react-redux'
import { ActsDesktopRoutes } from 'Pages/acts/routes/DesktopRoutes'
import { ActsMobileRoutes } from 'Pages/acts/routes/MobileRoutes'
import { useAppDispatch, useUnmount } from 'Src/hooks'

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
}

export const ActsRoutes = () => {
	const isMobile = useSelector(deviceDetect.getIsMobile)

	const { clearFilters } = useAppDispatch(actions)

	useUnmount(() => {
		clearFilters(PAGE_SLUG.NEW_ACTS)
	})

	return <>{isMobile ? <ActsMobileRoutes /> : <ActsDesktopRoutes />}</>
}
